/**
 * formatterDurationDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { decimalHoursToSeconds, hoursMinutesToSeconds, secondsToHoursMinutes } from '@shared/utils/datetime';

const REGEX_HOURS_MINUTE = /^(?:\d*:)?\d{0,2}$/;
const REGEX_DECIMAL_HOURS = /^(?:\d*\.)?\d*$/;
const REGEX_NATURAL_LANGUAGE = /^(?:(\d+)\s*(?:hours|hour|h))?(?:\s*(?:and)?\s*)?(?:(\d{0,2})\s*(?:m|min|mins|minute|minutes))?$/i;

formatterDurationDirective.$inject = [];

export function formatterDurationDirective() {
    return {
        priority: 100,
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attrs, controller) {
            controller.$formatters.push(durationFormatter);
            controller.$parsers.push(durationParser);
            controller.$validators.duration = durationValidator;

            element.on('blur keypress', event => {
                if (event.keyCode) {
                    if (event.keyCode !== 13) {
                        return;
                    }

                    event.preventDefault();
                }

                if (angular.isDefined(controller.$modelValue) && controller.$modelValue !== null) {
                    const hhmm = secondsToHoursMinutes(controller.$modelValue);

                    controller.$setViewValue(hhmm);
                    controller.$render();
                }
            });

            /**
             * Format the given number of seconds for displaying in the input.
             * If undefined is returned the placeholder is shown.
             *
             * @param seconds
             * @returns {string|undefined}
             */
            function durationFormatter(seconds) {
                if (seconds === null || seconds === undefined) {
                    return undefined;
                }

                return secondsToHoursMinutes(seconds);
            }

            function durationParser(input) {
                input = String(input);
                let output = null;

                if (input.length) {
                    // Is it a decimal
                    if (isDecimalHoursString(input)) {
                        output = decimalHoursToSeconds(input);
                    }
                    // Is it a HH:mm string
                    else if (isHoursMinuteString(input)) {
                        output = hoursMinutesToSeconds(input);
                    }
                    // Is it a natural language string
                    else if (isNaturalLanguage(input)) {
                        output = naturalLanguageToSeconds(input);
                    }
                }

                return output;
            }

            function durationValidator(modelValue, viewValue) {
                if (controller.$isEmpty(viewValue)) {
                    // consider empty models to be valid
                    return true;
                }

                return !controller.$isEmpty(modelValue);
            }
        },
    };

    function isDecimalHoursString(input) {
        return REGEX_DECIMAL_HOURS.test(String(input));
    }

    function isNaturalLanguage(input) {
        return REGEX_NATURAL_LANGUAGE.test(String(input));
    }

    function isHoursMinuteString(input) {
        return REGEX_HOURS_MINUTE.test(String(input));
    }

    function naturalLanguageToSeconds(input) {
        const matches = String(input).match(REGEX_NATURAL_LANGUAGE);

        if (!matches) {
            return null;
        }

        const hours: any = matches[1] || 0;
        const minutes: any = matches[2] || 0;

        return Math.floor(hours * 3600 + minutes * 60);
    }
}
